import React, { Component } from 'react';
import Uuid from '../../../../../support/Uuid';

import TrasladosLocalesForm from './TrasladosLocalesForm';
import TrasladosLocalesList from './TrasladosLocalesList';

class TrasladosLocalesManager extends Component {
  state = {
    editing: undefined
  };

  handleOnAdd = (data) => {
    const { TrasladosLocales = [] } = this.props.data;

    const newData = [].concat(TrasladosLocales, [{
      id: Uuid.v4(),
      ...data
    }]);

    this.setState({
      editing: undefined
    });

    this.props.onChange({
      TrasladosLocales: newData
    });
  }

  handleOnEdit = (item) => {
    this.handleOnDelete(item);

    setTimeout(() => {
      this.setState({
        editing: item
      });
    }, 1);
  }

  handleOnDelete = (item) => {
    const { TrasladosLocales = [] } = this.props.data;

    const newData = TrasladosLocales.filter((value) => item.id !== value.id);

    this.props.onChange({
      TrasladosLocales: newData
    });
  }

  render() {
    const { data } = this.props;
    const { editing } = this.state;

    return (
      <fieldset className="mt-3">
        <legend className="text-muted">Traslados Locales</legend>

        <TrasladosLocalesForm
          onAdd={ this.handleOnAdd }
          data={ editing }
        />

        <div className="py-2"></div>

        <TrasladosLocalesList
          data={ data.TrasladosLocales || [] }
          onEdit={ this.handleOnEdit }
          onDelete={ this.handleOnDelete }
        />
      </fieldset>
    )
  }
}

export default TrasladosLocalesManager;